import { Box, Divider } from '@factorialco/deprecated-design-system'

import { trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import useCallPageEvents from 'modules/onboarding/hooks/useCallPageEvents'
import useHubspotEvents from 'modules/onboarding/hooks/useHubspotEvents'
import useHubspotVariables from 'modules/onboarding/hooks/useHubspotVariables'

import PopoverItem from 'modules/onboarding/components/HelpButton/PopoverItem'
import { ModalStates } from 'modules/onboarding/components/HelpButton/types'

interface Props {
  handleOpenWidget: () => void
  handleStateChange: (state: Partial<ModalStates>) => void
}

const PopoverContent = ({ handleOpenWidget, handleStateChange }: Props) => {
  const { isChatAvailable, isMeetingAvailable, isCallPageAvailable, contactPhone } =
    useHubspotVariables()
  const { eventEmitter: hsEventEmitter } = useHubspotEvents({ from: 'help_button_popover' })
  const { eventEmitter: callPageEventEmitter } = useCallPageEvents({ from: 'help_button_popover' })

  return (
    <Box component="ul" paddingY="s12" role="menu">
      {isChatAvailable && (
        <PopoverItem
          icon="comment"
          title={i18n.t('help_widget.popover.chat.title')}
          description={i18n.t('help_widget.popover.chat.description')}
          onClick={() => {
            handleStateChange({ isHSModalOpen: true, isChatOpen: true, isPopoverOpen: false })
            hsEventEmitter(trackingEvents.onboarding.openHubspotChat)
          }}
        />
      )}
      {isCallPageAvailable && contactPhone && (
        <PopoverItem
          icon="phone"
          title={i18n.t('help_widget.popover.call.title')}
          description={i18n.t('help_widget.popover.call.description', {
            time_zone: contactPhone.timeZone,
          })}
          onClick={() => {
            handleStateChange({ isCallPageModalOpen: true, isPopoverOpen: false })
            callPageEventEmitter(trackingEvents.onboarding.openCallbox)
          }}
        />
      )}
      {isMeetingAvailable && (
        <PopoverItem
          icon="calendar"
          title={i18n.t('help_widget.popover.demo.title')}
          description={i18n.t('help_widget.popover.demo.description')}
          onClick={() => {
            handleStateChange({ isHSModalOpen: true, isMeetingOpen: true, isPopoverOpen: false })
            hsEventEmitter(trackingEvents.onboarding.openHubspotMeetings)
          }}
        />
      )}
      <Box component="li" paddingY="s12" style={{ color: 'grey200', background: 'grey200' }}>
        <Divider />
      </Box>
      <PopoverItem
        title={i18n.t('help_widget.popover.help.title')}
        description={i18n.t('help_widget.popover.help.description')}
        onClick={handleOpenWidget}
      />
    </Box>
  )
}

export default PopoverContent
